import { createStrings } from '@utils/local';
import { formatNumberWithSeparators } from '@utils/types';

export const moneyStrings = createStrings({
  ja: {
    yen: '円',
    formatYen: (n: number) => `${formatNumberWithSeparators(n)}${moneyStrings.yen}`,
    formatYenFront: (n: number) => `¥${formatNumberWithSeparators(n)}`,
  },
});
